<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  disabledPeriods: { type: Array, default: () => [] },
  error: { type: String, default: '' },
  index: { type: Number, required: true },
  value: { type: String, default: '' },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const periods = computed(() =>
  [
    {
      value: 'assinatura_recibo_sinal',
      label: t('SALES.COMMISSION.PERIODS.ASSINATURA_RECIBO_SINAL'),
    },
    {
      value: 'retirada_certidoes',
      label: t('SALES.COMMISSION.PERIODS.RETIRADA_CERTIDOES'),
    },
    {
      value: 'ato_escritura',
      label: t('SALES.COMMISSION.PERIODS.ATO_ESCRITURA'),
    },
    {
      value: 'transferencia_registros',
      label: t('SALES.COMMISSION.PERIODS.TRANSFERENCIA_REGISTROS'),
    },
  ].map(period => ({
    ...period,
    disabled:
      props.disabledPeriods.includes(period.value) &&
      props.value !== period.value,
  }))
);
</script>

<template>
  <fieldset data-test="commission-installment-period" class="min-w-0">
    <legend class="mb-1.5 text-[13px] font-semibold uppercase text-lais-text">
      {{ t('SALES.COMMISSION.PAYMENT.PERIOD_LABEL') }}
    </legend>
    <div class="flex flex-wrap gap-2">
      <label
        v-for="period in periods"
        :key="period.value"
        class="inline-flex min-h-9 items-center gap-2 rounded-lais border px-3 py-2 text-sm transition-colors"
        :class="[
          period.value === value
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
            : 'border-lais-border bg-white text-lais-text',
          period.disabled
            ? 'cursor-not-allowed opacity-50'
            : 'cursor-pointer hover:border-lais-primary',
        ]"
      >
        <input
          :name="`commission-period-${index}`"
          type="radio"
          :value="period.value"
          :checked="period.value === value"
          :disabled="period.disabled"
          @change="emit('update', period.value)"
        />
        <span>{{ period.label }}</span>
      </label>
    </div>
    <p v-if="error" class="mt-1.5 text-sm text-lais-danger">{{ error }}</p>
  </fieldset>
</template>
